import React, { useEffect, useRef, useState } from "react";
import MainPagetitle from "../../../layouts/MainPagetitle";
import LeadsCenteredModal from "../Leads/LeadsCenteredModal";
import DigitalLeadInfo from "./DigitalLeadInfo/DigitalLeadInfo";
import DigitalLeadStatus from "./DigitalLeadStatus/DigitalLeadStatus";

const DigitalMarketingHome = (props) => {
  const [leadsInfoData, setLeadsInfoData] = useState({});
  const [leadInfoTimeline, setLeadInfoTimeline] = useState("TODAY");
  const [leadInfoCustomTimeline, setLeadInfoCustomTimeline] =
    useState("CUSTOM");
  // ----------------------------------------------------------------
  const [leadStatusTimeline, setLeadStatusTimeline] = useState("TODAY");
  const [leadStatusCustomTimeline, setLeadStatusCustomTimeline] =
    useState("CUSTOM");

  const handleLeadInfoTimelineChange = (timeline) => {
    setLeadInfoTimeline(timeline);
  };

  const handleLeadInfoCustomTimelineChange = (customTimeline) => {
    // console.log({ customTimeline });
    setLeadInfoCustomTimeline(customTimeline);
  };

  const handleLeadStatusTimelineChange = (timeline) => {
    setLeadStatusTimeline(timeline);
  };

  const handleLeadStatusCustomTimelineChange = (customTimeline) => {
    setLeadStatusCustomTimeline(customTimeline);
  };

  // ----------------------------------------------------------------
  const changePasswordModalRef = useRef(0);
  const [popupChangePasswordFields, setPopupChangePasswordFields] = useState(
    {}
  );
  const [changepasswordData, setChangepasswordData] = useState({});
  const [changepasswordFields, setChangepasswordFields] = useState([
    {
      label: "Old Password",
      name: "oldPassword",
      type: "password",
      customcolspan: "12",
    },
    {
      label: "New Password ",
      name: "newPassword",
      type: "password",
      customcolspan: "12",
    },
    {
      label: "Confirm Password",
      name: "confirmPassword",
      type: "password",
      customcolspan: "12",
    },
  ]);

  // HANDLE CHANGE PASSWORD MODAL
  const openChangePasswordmodal = () => {
    changePasswordModalRef.current.click();
  };

  const closeChangePasswordmodal = () => {
    document.querySelector("#changepasswordModal #bsmodalclose").click();
    setChangepasswordData({});
    setPopupChangePasswordFields({});
  };

  const addChangepasswordData = () => {
    let fields = (changepasswordFields || []).reduce(
      (o, n) => ({ ...o, [n.name]: n }),
      {}
    );
    let formdata = Object.map(fields, (v, k) => "");
    // console.log("formdata: ", fields, formdata);
    setPopupChangePasswordFields(fields);
    setChangepasswordData(formdata);
    openChangePasswordmodal();
  };

  const handleChangePasswordSubmit = (e, data) => {
    console.log({ handleChangePasswordSubmit: data });
    if (data.newPassword !== data.confirmPassword) {
      swal2.fire({
        title: "Password and Confirm Password does not match",
        icon: "warning",
        iconColor: "#BB1766",
        timer: 4000,
      });
    } else {
      let payload = {
        oldPassword: data.oldPassword,
        newPassword: data.newPassword,
      };

      props.apis.apiPasswordReset(payload).then((res) => {
        console.log({ apiPasswordReset: res });
        if (res.status === 200) {
          swal2
            .fire({
              title:
                "Password changed successfully, Please re-login with new password",
              icon: "success",
              iconColor: "#BB1766",
            })
            .then((result) => {
              if (result.isConfirmed) {
                closeChangePasswordmodal();
                props?.apis?.applogout();
                props?.navigate("/open/login");
              }
            });
        }
      });
    }
  };

  // ------------------
  useEffect(() => {
    const { isPasswordUpdated, role } = props?.$store?.user;
    if (!isPasswordUpdated & (role !== _enum.PERSONAS.admin)) {
      addChangepasswordData();
    }
  }, []);

  props.$setNode({
    props,
    leadsInfoData,
  });
  return (
    <>
      <MainPagetitle
        mainTitle="Dashboard"
        pageTitle="Dashboard"
        parentTitle="Home"
        pageIcon={imagepaths.DashboardActive}
      />
      <div className="container-fluid">
        <h2 className="fs-4 mb-3">Lead Info</h2>
        <DigitalLeadInfo
          onLeadInfoTimelineChange={handleLeadInfoTimelineChange}
          onLeadInfoCustomTimelineChange={handleLeadInfoCustomTimelineChange}
        />

        <h2 className="fs-4 mt-4 mb-3">Lead Status</h2>
        <DigitalLeadStatus
          onLeadStatusTimelineChange={handleLeadStatusTimelineChange}
          onLeadStatusCustomTimelineChange={
            handleLeadStatusCustomTimelineChange
          }
        />
      </div>

      {/* below button hidden on UI */}
      <button
        className="btn btn-sm btn-outline-secondary d-none"
        onClick={(e) => addChangepasswordData(e)}
        ref={changePasswordModalRef}
        data-bs-toggle="modal"
        data-bs-target="#changepasswordModal"
      >
        <span>Change Password</span>
      </button>

      <LeadsCenteredModal
        id="changepasswordModal"
        title="Change Password"
        submitText="Chage Password"
        hidecancelbtn={true}
        data={changepasswordData}
        fields={popupChangePasswordFields}
        onSubmit={(...args) => handleChangePasswordSubmit(...args)}
        modaltype="centeredmodal"
        onClose={() => closeChangePasswordmodal()}
      />
    </>
  );
};

export default constore(DigitalMarketingHome);
